// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2c17V","top":"styles_top__2_hJ0"};